import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';
import Strong from '@tds/core-strong';

import { Thead, Tr, Th, Td } from './css';
import getFormattedPricing from '../../utils';
import Row from './row';

const Table = ({ viewType, addons, setAddons, list, total, setTotal }) => {
  const getHeader = headerList => (
    <Thead>
      <Tr>
        {headerList.map(item => (
          <Th>{_.get(item, 'fields.title', '')}</Th>
        ))}
      </Tr>
    </Thead>
  );

  useEffect(() => {
    const grandTotal = Object.keys(addons).reduce((acc, current) => {
      const { unitPrice, quantity } = addons[current];
      return acc + unitPrice * +quantity;
    }, 0);
    setTotal(previousValue => ({ ...previousValue, addons: grandTotal }));
  }, [addons]);
  return (
    <table>
      {list.map(addon =>
        _.get(addon, 'fields.isHeader', false) ? (
          getHeader(_.get(addon, 'fields.headerList', []))
        ) : (
          <Row
            key={addon.addonName}
            rowData={addon}
            viewType={viewType}
            addons={addons}
            setAddons={setAddons}
          />
        )
      )}
      <Tr style={{ background: '#f4f4f4' }}>
        <Td colSpan={3}>
          <Strong>Total</Strong>
        </Td>
        <Td>
          <Strong>{getFormattedPricing(total)}</Strong>
        </Td>
      </Tr>
    </table>
  );
};

Table.propTypes = {
  viewType: PropTypes.string.isRequired,
  addons: PropTypes.arrayOf(PropTypes.object).isRequired,
  setAddons: PropTypes.func.isRequired,
  list: PropTypes.arrayOf(PropTypes.object).isRequired,
  total: PropTypes.number.isRequired,
  setTotal: PropTypes.func.isRequired
};

export default Table;
